import { Directive, OnInit, OnChanges, Input, ElementRef, Self, Inject, PLATFORM_ID, Optional } from '@angular/core';
import { BaseFxDirective, MediaMonitor, StyleUtils, SERVER_TOKEN } from '@angular/flex-layout';
import { MatGridList, MatGridTile } from '@angular/material';

@Directive({
  selector:  `
  mat-grid-tile[colspan.xs],    mat-grid-tile[colspan.sm],    mat-grid-tile[colspan.md],    mat-grid-tile[colspan.lg],   mat-grid-tile[colspan.xl],
  mat-grid-tile[colspan.lt-sm], mat-grid-tile[colspan.lt-md], mat-grid-tile[colspan.lt-lg], mat-grid-tile[colspan.lt-xl],
  mat-grid-tile[colspan.gt-xs], mat-grid-tile[colspan.gt-sm], mat-grid-tile[colspan.gt-md], mat-grid-tile[colspan.gt-lg]
`
})
export class ResponsiveGridTileDirective extends BaseFxDirective implements OnInit, OnChanges {

  /* tslint:disable */
  @Input('colspan')        set colspanBase(val) { this._cacheInput('colspan', val);  }

  @Input('colspan.xs')     set colspanXs(val)   { this._cacheInput('colspanXs', val);  }
  @Input('colspan.sm')     set colspanSm(val)   { this._cacheInput('colspanSm', val);  }
  @Input('colspan.md')     set colspanMd(val)   { this._cacheInput('colspanMd', val);  }
  @Input('colspan.lg')     set colspanLg(val)   { this._cacheInput('colspanLg', val);  }
  @Input('colspan.xl')     set colspanXl(val)   { this._cacheInput('colspanXl', val);  }

  @Input('colspan.lt-sm')  set colspanLtSm(val) { this._cacheInput('colspanLtSm', val);  }
  @Input('colspan.lt-md')  set colspanLtMd(val) { this._cacheInput('colspanLtMd', val);  }
  @Input('colspan.lt-lg')  set colspanLtLg(val) { this._cacheInput('colspanLtLg', val);  }
  @Input('colspan.lt-xl')  set colspanLtXl(val) { this._cacheInput('colspanLtXl', val);  }

  @Input('colspan.gt-xs')  set colspanGtXs(val) { this._cacheInput('colspanGtXs', val);  }
  @Input('colspan.gt-sm')  set colspanGtSm(val) { this._cacheInput('colspanGtSm', val);  }
  @Input('colspan.gt-md')  set colspanGtMd(val) { this._cacheInput('colspanGtMd', val);  }
  @Input('colspan.gt-lg')  set colspanGtLg(val) { this._cacheInput('colspanGtLg', val);  }
  /* tslint:enable */

  constructor(protected _elRef: ElementRef,
              protected _monitor: MediaMonitor,
              protected _styler: StyleUtils,
              @Self() protected _gridTile: MatGridTile,
              @Inject(PLATFORM_ID) protected _platformId: Object,
              @Optional() @Inject(SERVER_TOKEN) protected _serverModuleLoaded: boolean) {
    super(_monitor, _elRef, _styler);
    this._cacheInput('colspan', _gridTile.colspan || '');
  }

  /**
   * Listen for responsive changes to update the img.src attribute
   */
  ngOnInit() {
    super.ngOnInit();

    if (this.hasResponsiveKeys) {
      // Listen for responsive changes
      this._listenForMediaQueryChanges('colspan', this._queryInput('colspan'), () => {
        this._update();
      });
    }
    this._update();
  }

  /**
   * Update the 'src' property of the host <img> element
   */
  ngOnChanges() {
    if (this.hasInitialized) {
      this._update();
    }
  }

    protected _update() {
    if (this.hasResponsiveKeys) {
      let value = this.activatedValue || this._queryInput('colspan');
      this._gridTile.colspan = Number(value);
    }
  }

    protected get hasResponsiveKeys() {
    return Object.keys(this._inputMap).length > 1;
  }

}


// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/directives/responsive-grid-tile.directive.ts